import { Card, Typography, Input, Button, Form, Empty, Checkbox, Divider } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import * as Apis from "../../../utils/helper/enum";
import { changeLoader } from "../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { capitalizeName, checkPermissionAction } from "../../../utils/helper/utils";
import { jwtDecode } from "jwt-decode";
import { addDeleteGetLocalStorage, storageKeys } from "../../../utils/global/localData";

const CreateRole = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const defaultPermissions = [
    {
      moduleName: "Manage QC",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Manage Vendor",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Manage Canned Seller",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Manage Driver",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Manage Sub Admin",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Roles",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Business Categories",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Zones",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Zone specific Timeslots & Holidays",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Vehicle Type",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Packaging Type",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Drop zone",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Canned Vending Machine",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Item Sensitivity",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Manage CMS",
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "System Settings",
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Vendor Payouts",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Driver Payouts",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Order Management",
      edit: 0,
      view: 0,
      resend_to_customer_approval: 0,
      moved_to_preparing: 0,
      moved_to_ready_to_ship: 0,
      move_to_complete: 0,
      assign_qc: 0,
      assign_driver: 0,
      submit_to_qc: 0,
      cancel: 0,
      refund: 0,
      reschedule: 0,
      download_invoice: 0,
      deduction: 0,
      delay_message: 0,
      view_otp: 0,
      assign_locker: 0,
      open_locker: 0,
      mark_complete: 0,
      reactivate_order: 0,
      bulk_upload: 0,
      pin_code: 0,
    },
    {
      moduleName: "Product Management",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Manage Modifiers",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Sales By Zone Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Sales By Item Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Sales By Customer Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Sales By Order Type Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Sales By Delivery Mode Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Sales By Time Slot Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Sales By Vendor Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Sales By Driver Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Sales Details Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Coupon Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Payment Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Late Order Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Refund Order Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Cancelled Order Report",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Wallet Reports",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Driver Reports",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Admin Activity Logs",
      view: 0,
      export: 0,
    },
    {
      moduleName: "Manage Coupon",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Subscriptions",
      add: 0,
      edit: 0,
      delete: 0,
      view: 0,
      update_status: 0,
    },
    {
      moduleName: "Canned Order Management",
      edit: 0,
      view: 0,
      pin_code: 0,
    },
  ];
  const [roleName, setRoleName] = useState("");
  const [roleNameErr, setRoleNameErr] = useState("");

  const [permission, setPermission] = useState(defaultPermissions);

  const mergePermissions = (defaultPermissions, responsePermissions) => {
    return defaultPermissions.map((defaultPerm) => {
      const responsePerm = responsePermissions.find(
        (resPerm) => resPerm.moduleName === defaultPerm.moduleName
      );

      // Merge response permission values into default
      return {
        ...defaultPerm,
        ...responsePerm,
      };
    });
  };

  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
    }
    if (id) {
      if (!checkPermissionAction("Roles", permissionJson, "edit")) {
        navigate("/roles-permissions");
      }
    } else {
      if (!checkPermissionAction("Roles", permissionJson, "add")) {
        navigate("/roles-permissions");
      }
      setPermission(defaultPermissions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const selectAllCheckBox = async (value) => {
    let getValue = value ? 1 : 0;
    setPermission([
      {
        moduleName: "Manage QC",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Manage Vendor",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Manage Canned Seller",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Manage Driver",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Manage Sub Admin",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Roles",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Business Categories",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Zones",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Zone specific Timeslots & Holidays",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Vehicle Type",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Packaging Type",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Drop zone",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Canned Vending Machine",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Item Sensitivity",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Manage Coupon",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Subscriptions",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Manage CMS",
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "System Settings",
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Vendor Payouts",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Driver Payouts",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Order Management",
        edit: getValue,
        view: getValue,
        resend_to_customer_approval: getValue,
        moved_to_preparing: getValue,
        moved_to_ready_to_ship: getValue,
        move_to_complete: getValue,
        assign_qc: getValue,
        assign_driver: getValue,
        submit_to_qc: getValue,
        cancel: getValue,
        refund: getValue,
        reschedule: getValue,
        download_invoice: getValue,
        deduction: getValue,
        delay_message: getValue,
        view_otp: getValue,
        assign_locker: getValue,
        open_locker: getValue,
        mark_complete: getValue,
        reactivate_order: getValue,
        bulk_upload: getValue,
        pin_code: getValue,
      },
      {
        moduleName: "Product Management",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Manage Modifiers",
        add: getValue,
        edit: getValue,
        delete: getValue,
        view: getValue,
        update_status: getValue,
      },
      {
        moduleName: "Sales By Zone Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Sales By Item Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Sales By Customer Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Sales By Order Type Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Sales By Delivery Mode Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Sales By Time Slot Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Sales By Vendor Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Sales By Driver Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Sales Details Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Coupon Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Payment Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Wallet Reports",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Driver Reports",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Admin Activity Logs",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Late Order Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Cancelled Order Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Refund Order Report",
        view: getValue,
        export: getValue,
      },
      {
        moduleName: "Canned Order Management",
        edit: getValue,
        view: getValue,
        pin_code: getValue,
      },
    ]);
  };

  //Get role Data
  const getRoleData = useCallback(async () => {
    dispatch(changeLoader(true));
    let response = await globalRequest(Apis.MANAGE_ROLES_AND_PERMIISION.GET_DETAIL + "/" + id, "get", {}, {}, true);
    let apiResponse = response?.data;
    if (apiResponse?.status === "SUCCESS") {
      setRoleName(apiResponse?.data?.subadminRoleName);
      const merged = mergePermissions(defaultPermissions, apiResponse?.data?.permissionJson);
      setPermission(merged);
    } else {
      // toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  }, [dispatch, id]);

  useEffect(() => {
    if (id) getRoleData();
  }, [id, getRoleData]);

  const submitHandler = async () => {
    if (roleName === "") {
      setRoleNameErr("Name is required");
      return false;
    }

    if (permission) {
      let tk = false;
      for (let item of permission) {
        if (item.add === 1 || item.add === "1") tk = true;
        if (item.delete === 1 || item.delete === "1") tk = true;
        if (item.edit === 1 || item.edit === "1") tk = true;
        if (item.update_status === 1 || item.update_status === "1") tk = true;
        if (item.view === 1 || item.view === "1") tk = true;
      }
      if (!tk) {
        toast.error("Choose at least 1 permission.");
        return false;
      }
    }

    let data = {
      role_name: roleName,
      permission: permission,
    };
    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_ROLES_AND_PERMIISION?.CREATE;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_ROLES_AND_PERMIISION?.EDIT + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, data, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Role created successfully";
        if (id) msg = "Role updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/roles-permissions");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  return (
    <>
      <Card>
        <div className="flex items-center justify-between relative mb-4">
          <Typography className="text-xl font-semibold mb-0" align={"left"}>
            <LeftOutlined onClick={() => navigate(-1)} className="text=lg text-black mr-2 cursor-pointer" />
            {id ? "Edit Roles" : "Create Roles"}
          </Typography>
        </div>
        <Divider />
        <div className="mb-0 flex justify-between flex-wrap">
          <Form layout="horizontal" className="flex flex-col gap-4 w-full mb-6">
            <div className="flex gap-4 items-center justify-between w-full">
              <Form.Item label="Role Name" className="mb-0">
                <Input
                  className=""
                  placeholder="Role name"
                  disabled={id === 1 || id === "1" ? true : false}
                  value={roleName}
                  maxLength={50}
                  onChange={(e) => {
                    setRoleName(e.target.value.trimStart());
                    setRoleNameErr("");
                  }}
                />
              </Form.Item>
              {id !== 1 ? (
                <div className="flex items-center gap-2">
                  <Checkbox
                    onChange={(e) => {
                      selectAllCheckBox(e.target.checked);
                    }}
                  />{" "}
                  select all
                </div>
              ) : null}
            </div>
            {roleNameErr && (
              <div
                style={{
                  color: "#DC362E",
                  textAlign: "initial",
                  bottom: "-16px",
                }}
                className="errorSize"
              >
                {roleNameErr}
              </div>
            )}
          </Form>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Module
                </th>
                <th scope="col" className="px-3 py-3 text-center whitespace-nowrap">
                  Read
                </th>
                <th scope="col" className="px-3 py-3 text-center whitespace-nowrap">
                  Edit
                </th>
                <th scope="col" className="px-3 py-3 text-center whitespace-nowrap">
                  Delete
                </th>
                <th scope="col" className="px-3 py-3 text-center whitespace-nowrap ">
                  Add
                </th>
                <th scope="col" className="px-3 py-3 text-center whitespace-nowrap ">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {permission && permission.length > 0 ? (
                permission?.map((item, index) => (
                  <tr key={index} className="bg-white border-b">
                    <th scope="row" className="px-3 py-4 font-medium text-gray-900 whitespace-nowrap vertical-top">
                      {capitalizeName(item.moduleName)}
                    </th>
                    <td className="px-3 py-4 vertical-top text-center">
                      {item?.view !== undefined ? (
                        <Checkbox
                          checked={item.view}
                          disabled={id === 1 || id === "1" ? true : false}
                          onChange={() => {
                            let prevData = [...permission];
                            prevData[index].view = item.view ? 0 : 1;

                            if (item.view === 0) {
                              if (item.moduleName === "Manage CMS" || item.moduleName === "System Settings") {
                                prevData[index].edit = 0;
                                prevData[index].update_status = 0;
                                prevData[index].delete = 0;
                              } else if (
                                item.moduleName === "Vendor Payouts" ||
                                item.moduleName === "Driver Payouts" ||
                                item.moduleName === "Sales By Zone Report" ||
                                item.moduleName === "Sales By Item Report" ||
                                item.moduleName === "Sales By Customer Report" ||
                                item.moduleName === "Sales By Order Type Report" ||
                                item.moduleName === "Sales By Delivery Mode Report" ||
                                item.moduleName === "Sales By Time Slot Report" ||
                                item.moduleName === "Sales By Vendor Report" ||
                                item.moduleName === "Sales By Driver Report" ||
                                item.moduleName === "Coupon Report" ||
                                item.moduleName === "Payment Report" ||
                                item.moduleName === "Refund Order Report" ||
                                item.moduleName === "Late Order Report" ||
                                item.moduleName === "Cancelled Order Report" ||
                                item.moduleName === "Sales Details Report" ||
                                item.moduleName === "Wallet Reports" ||
                                item.moduleName === "Driver Reports" ||
                                item.moduleName === "Admin Activity Logs"
                              ) {
                                // prevData[index].edit = 0;
                                prevData[index].export = 0;
                              } else if (item.moduleName === "Order Management") {
                                prevData[index].edit = 0;
                                prevData[index].resend_to_customer_approval = 0;
                                prevData[index].moved_to_preparing = 0;
                                prevData[index].moved_to_ready_to_ship = 0;
                                prevData[index].move_to_complete = 0;
                                prevData[index].assign_qc = 0;
                                prevData[index].assign_driver = 0;
                                prevData[index].submit_to_qc = 0;
                                prevData[index].cancel = 0;
                                prevData[index].refund = 0;
                                prevData[index].reschedule = 0;
                                prevData[index].download_invoice = 0;
                                prevData[index].assign_locker = 0;
                                prevData[index].open_locker = 0;
                                prevData[index].mark_complete = 0;
                                prevData[index].reactivate_order = 0;
                                prevData[index].bulk_upload = 0;
                                prevData[index].pin_code = 0;
                              } else if (item.moduleName === "Canned Order Management") { 
                                prevData[index].edit = 0;
                                prevData[index].pin_code = 0;
                                prevData[index].view = 0;
                              }
                              else {
                                prevData[index].edit = 0;
                                prevData[index].add = 0;
                                prevData[index].update_status = 0;
                                prevData[index].delete = 0;
                              }
                            }

                            setPermission(prevData);
                          }}
                        />
                      ) : null}
                    </td>
                    <td className="px-3 py-4 vertical-top text-center">
                      {item?.edit !== undefined ? (
                        <Checkbox
                          checked={item.edit}
                          disabled={id === 1 || id === "1" ? true : false}
                          onChange={() => {
                            if (item.view !== 1) return false;
                            else {
                              let prevData = [...permission];
                              prevData[index].edit = item.edit ? 0 : 1;
                              setPermission(prevData);
                            }
                          }}
                        />
                      ) : null}
                    </td>
                    <td className="px-3 py-4 vertical-top text-center">
                      {item?.delete !== undefined ? (
                        <Checkbox
                          checked={item.delete}
                          disabled={id === 1 || id === "1" ? true : false}
                          onChange={() => {
                            if (item.view !== 1) return false;
                            else {
                              let prevData = [...permission];
                              prevData[index].delete = item.delete ? 0 : 1;
                              setPermission(prevData);
                            }
                          }}
                        />
                      ) : null}
                    </td>
                    <td className="px-3 py-4 vertical-top text-center">
                      {item?.add !== undefined ? (
                        <Checkbox
                          checked={item.add}
                          disabled={id === 1 || id === "1" ? true : false}
                          onChange={() => {
                            if (item.view !== 1) return false;
                            else {
                              let prevData = [...permission];
                              prevData[index].add = item.add ? 0 : 1;
                              setPermission(prevData);
                            }
                          }}
                        />
                      ) : null}
                    </td>
                    <td className="px-3 py-4 vertical-top text-center">
                      {item.moduleName === "Vendor Payouts" ||
                      item.moduleName === "Driver Payouts" ||
                      item.moduleName === "Sales By Zone Report" ||
                      item.moduleName === "Sales By Item Report" ||
                      item.moduleName === "Sales By Customer Report" ||
                      item.moduleName === "Sales By Order Type Report" ||
                      item.moduleName === "Sales By Delivery Mode Report" ||
                      item.moduleName === "Sales By Time Slot Report" ||
                      item.moduleName === "Sales By Vendor Report" ||
                      item.moduleName === "Sales By Driver Report" ||
                      item.moduleName === "Coupon Report" ||
                      item.moduleName === "Payment Report" ||
                      item.moduleName === "Refund Order Report" ||
                      item.moduleName === "Late Order Report" ||
                      item.moduleName === "Cancelled Order Report" ||
                      item.moduleName === "Sales Details Report"  || 
                      item.moduleName === "Wallet Reports" || 
                      item.moduleName === "Driver Reports" ||
                      item.moduleName === "Admin Activity Logs" ? (
                        item?.export !== undefined ? (
                          <>
                            <Checkbox
                              checked={item.export}
                              disabled={id === 1 || id === "1" ? true : false}
                              onChange={() => {
                                if (item.view !== 1) return false;
                                else {
                                  let prevData = [...permission];
                                  prevData[index].export = item.export ? 0 : 1;
                                  setPermission(prevData);
                                }
                              }}
                            />
                            <p className="whitespace-nowrap">Export</p>
                          </>
                        ) : null
                      ) : null}

                      {item.moduleName !== "Order Management" ? (
                        item?.update_status !== undefined ? (
                          <>
                            <Checkbox
                              checked={item.update_status}
                              disabled={id === 1 || id === "1" ? true : false}
                              onChange={() => {
                                if (item.view !== 1) return false;
                                else {
                                  let prevData = [...permission];
                                  prevData[index].update_status = item.update_status ? 0 : 1;
                                  setPermission(prevData);
                                }
                              }}
                            />
                            <p className="whitespace-nowrap">Active/Inactive</p>
                          </>
                        ) : null
                      ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-3">
                          {/* resend to customer approval */}
                          {item?.resend_to_customer_approval !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.resend_to_customer_approval}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].resend_to_customer_approval = item.resend_to_customer_approval ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Resend to customer approval</p>
                              </div>
                            </>
                          ) : null}

                          {/* Move to preparing */}
                          {item?.moved_to_preparing !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.moved_to_preparing}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].moved_to_preparing = item.moved_to_preparing ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Move to preparing</p>
                              </div>
                            </>
                          ) : null}

                          {/* moved to ready to ship */}
                          {item?.moved_to_ready_to_ship !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.moved_to_ready_to_ship}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].moved_to_ready_to_ship = item.moved_to_ready_to_ship ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Move to ready to ship</p>
                              </div>
                            </>
                          ) : null}

                          {/* move to complete */}
                          {item?.move_to_complete !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.move_to_complete}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].move_to_complete = item.move_to_complete ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Mark as complete</p>
                              </div>
                            </>
                          ) : null}

                          {/* move to complete */}
                          {/* {item?.move_to_complete !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.move_to_complete}
                                  disabled={
                                    id === 1 || id === "1" ? true : false
                                  }
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].move_to_complete =
                                        item.move_to_complete ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">
                                  Move to complete
                                </p>
                              </div>
                            </>
                          ) : null} */}

                          {/* assign qc */}
                          {item?.assign_qc !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.assign_qc}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].assign_qc = item.assign_qc ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Assign QC</p>
                              </div>
                            </>
                          ) : null}

                          {/* assign driver */}
                          {item?.assign_driver !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.assign_driver}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].assign_driver = item.assign_driver ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Assign driver</p>
                              </div>
                            </>
                          ) : null}

                          {/* Submit to QC   */}
                          {item?.submit_to_qc !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.submit_to_qc}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].submit_to_qc = item.submit_to_qc ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Submit to QC</p>
                              </div>
                            </>
                          ) : null}

                          {/* cancel */}
                          {item?.cancel !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.cancel}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].cancel = item.cancel ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Cancel</p>
                              </div>
                            </>
                          ) : null}

                          {/* refund */}
                          {item?.refund !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.refund}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].refund = item.refund ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Refund</p>
                              </div>
                            </>
                          ) : null}

                          {/* reschedule */}
                          {item?.reschedule !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.reschedule}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].reschedule = item.reschedule ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Reschedule</p>
                              </div>
                            </>
                          ) : null}

                          {/* download_invoice */}
                          {item?.download_invoice !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.download_invoice}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].download_invoice = item.download_invoice ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Download invoice</p>
                              </div>
                            </>
                          ) : null}

                          {/* deduction */}
                          {item?.deduction !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.deduction}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].deduction = item.deduction ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Deduction</p>
                              </div>
                            </>
                          ) : null}

                          {/* delay_message */}
                          {item?.delay_message !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.delay_message}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].delay_message = item.delay_message ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Delay Message</p>
                              </div>
                            </>
                          ) : null}

                          {/* View OTP */}
                          {item?.view_otp !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.view_otp}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].view_otp = item.view_otp ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">View OTP</p>
                              </div>
                            </>
                          ) : null}
                           {/* assign Locker */}
                          {item?.assign_locker !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.assign_locker}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].assign_locker = item.assign_locker ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Assign Locker</p>
                              </div>
                            </>
                          ) : null}

                          {/* open Locker */}
                          {item?.open_locker !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.open_locker}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].open_locker = item.open_locker ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Open Locker</p>
                              </div>
                            </>
                          ) : null}
                          {item?.mark_complete !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.mark_complete}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].mark_complete= item.mark_complete ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Mark Complete (Skip OTP)</p>
                              </div>
                            </>
                          ) : null}
                          {item?.reactivate_order !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.reactivate_order}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].reactivate_order = item.reactivate_order ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Reactivate order</p>
                              </div>
                            </>
                          ) : null}
                          {item?.bulk_upload !== undefined ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.bulk_upload}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].bulk_upload = item.bulk_upload ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Bulk Upload</p>
                              </div>
                            </>
                          ) : null}
                          {(item?.pin_code !== undefined) ? (
                            <>
                              <div>
                                <Checkbox
                                  checked={item.pin_code}
                                  disabled={id === 1 || id === "1" ? true : false}
                                  onChange={() => {
                                    if (item.view !== 1) return false;
                                    else {
                                      let prevData = [...permission];
                                      prevData[index].pin_code = item.pin_code ? 0 : 1;
                                      setPermission(prevData);
                                    }
                                  }}
                                />
                                <p className="whitespace-nowrap">Pin Code</p>
                              </div>
                            </>
                          ) : null}
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end flex-wrap gap-3 mt-4">
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button disabled={id === 1 || id === "1" ? true : false} type="primary" onClick={() => submitHandler()}>
            {id ? "Edit" : "Create"} Role
          </Button>
        </div>
      </Card>
    </>
  );
};
export default CreateRole;
